<div
  class="kr-exchange-details__title"
  translate="exchange.dialog.exchangeDetails"></div>
<div class="kr-exchange-details__row">
  <kr-wallet-card
    data-testid="exchange_crypto_crypto_details_wallet_from"
    [wallet]="walletFrom" />
  <fu-icon
    class="kr-exchange-details__icon-arrow"
    iconName="arrow-right-filled"
    size="48">
  </fu-icon>
  <kr-wallet-card
    data-testid="exchange_crypto_crypto_details_wallet_to"
    [wallet]="walletTo" />
</div>
<div class="kr-exchange-details__grid">
  <div class="kr-details">
    <label class="kr-details__label" translate="exchange.dialog.fromWallet">
    </label>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_crypto_details_from">
      {{ walletFrom?.address }}
    </span>
  </div>

  <div class="kr-details">
    <label class="kr-details__label" translate="exchange.dialog.amount">
    </label>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_crypto_details_wallet_amount"
      >{{
        estimation()?.totalValueToSend.amount.toString()
          | balanceFormat: estimation()?.totalValueToSend.symbol
      }}
      {{ estimation()?.totalValueToSend.symbol }}</span
    >
    <span class="kr-details__hint"
      >({{ 'exchange.dialog.approximate' | translate }})</span
    >
  </div>

  <div class="kr-details">
    <label class="kr-details__label" translate="exchange.dialog.toWallet">
    </label>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_crypto_details_wallet_to">
      {{ walletTo?.address }}
    </span>
  </div>

  <div class="kr-details">
    <label
      class="kr-details__label"
      translate="exchange.dialog.amountToReceive">
    </label>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_crypto_details_value_receive"
      >{{
        estimation()?.valueToReceive.amount.toString()
          | balanceFormat: estimation()?.valueToReceive.symbol
      }}
      {{ estimation()?.valueToReceive.symbol }}</span
    >
  </div>
</div>
<div class="kr-exchange-details__row-between kr-margin-top">
  <div class="kr-details">
    <label
      class="kr-details__label kr-margin-bottom"
      translate="exchange.dialog.rate">
    </label>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_crypto_details_rate"
      [class]="timeLeft() === 0 ? 'kr-details__danger' : null">
      1 {{ walletFrom?.coin.symbol }} =
      {{ estimation()?.rate.toString() | balanceFormat: walletTo.coin.symbol }}
      {{ walletTo?.coin.symbol }}
    </span>
  </div>

  <div class="kr-details">
    <div class="kr-exchange-details__row-start">
      <label class="kr-details__label" translate="exchange.dialog.estimatedFee">
      </label>
      <kr-copy-tooltip
        [text]="'exchange.dialog.estimatedFeeCharge' | translate"
        [copy]="false" />
    </div>

    <span
      class="kr-details__value"
      data-testid="exchange_crypto_crypto_details_fee"
      [class]="timeLeft() === 0 ? 'kr-details__danger' : null"
      >{{
        estimation()?.operationFee.amount.toString()
          | balanceFormat: estimation()?.operationFee.symbol
      }}
      {{ estimation()?.operationFee.symbol }}</span
    >
  </div>

  <div class="kr-details">
    <label class="kr-details__label" translate="exchange.dialog.expires">
    </label>

    @if (!timeLeft()) {
      <button
        type="button"
        fuButton
        size="s"
        uiType="primary"
        data-testid="exchange_crypto_crypto_details_reset_timer"
        (click)="resetTimer()"
        translate="Update"></button>
    } @else {
      <span class="kr-details__value">
        {{ 'exchange.dialog.in' | translate }} {{ timeLeft() }}
        {{ 'exchange.dialog.sec' | translate }}
      </span>
    }
  </div>
</div>
